module.exports = __webpack_public_path__ + "assets/img/quick-start.9b8393dc.png";